import { render } from "./CommentActivity.vue?vue&type=template&id=74d4afa6"
import script from "./CommentActivity.vue?vue&type=script&lang=js"
export * from "./CommentActivity.vue?vue&type=script&lang=js"

import "./CommentActivity.vue?vue&type=style&index=0&id=74d4afa6&lang=scss"
script.render = render

export default script